import { FC, ReactNode } from "react";
import WidgetLoading from "./WidgetLoading";
import WidgetError from "@components/errors/widgets";

interface WidgetContainerProps {
    children?: ReactNode;
    className?: string;
    title?: string | ReactNode;
    isError?: boolean;
    sider?: ReactNode;
    controls?: ReactNode;
    isLoading?: boolean;
    contentClassName?: string;
    customLoadingBody?: ReactNode;
    loadingClass?: string;
    paddingless?: boolean;
}

const WidgetContainer: FC<WidgetContainerProps> = ({
    children,
    className,
    title,
    isError,
    sider,
    controls,
    isLoading,
    contentClassName,
    loadingClass,
    paddingless,
}) => {
    if (isLoading) {
        return <WidgetLoading className={loadingClass} />;
    }

    return (
        <div
            className={`flex flex-1 overflow-hidden rounded-widget border border-border-elevated ${className}`}
        >
            <div className={`flex w-full flex-1 flex-col ${contentClassName}`}>
                {(title ?? controls) && (
                    <div
                        className={`mb-4 flex items-center gap-4 px-widgetx pt-widgety ${
                            !children && "pb-2"
                        }`}
                    >
                        <h2 className="flex-1 text-xl text-text-heading">
                            {title}
                        </h2>
                        {controls}
                    </div>
                )}
                {isError ? (
                    <WidgetError />
                ) : (
                    children && (
                        <div
                            className={`w-full ${
                                !paddingless && "px-widgetx pb-widgety"
                            } h-full`}
                        >
                            {children}
                        </div>
                    )
                )}
            </div>
            {sider && (
                <div className="text-1xl flex min-w-[4em] items-center justify-center overflow-hidden rounded-r-3xl border-l border-background-lighter bg-background-lighter font-semibold text-primary-accent">
                    {sider}
                </div>
            )}
        </div>
    );
};

export default WidgetContainer;
